import { callFetch } from './serviceHelpers';

export const getOrderRequest = async orderId => {
  return callFetch(`${process.env.REACT_APP_ORDER_REQUEST_URL}/v1/orders/${orderId}`);
};

export const getPreferredOrder = async orderId => {
  return callFetch(`${process.env.REACT_APP_ORDER_REQUEST_URL}/v1/preferredOrders/${orderId}`);
};
